import { isPartnerConnectionsEnabled } from '../../config/partnerConnections';

const STORAGE_KEY = 'rx-coverage-pending-invitation';

// A one-time company invitation must survive sign-in. Only this invitation
// (never a widget token or API key) is kept in this tab for at most one hour.
// Remove the fragment before analytics/authentication mount.
export function captureConnectionInvitation() {
  if (!isPartnerConnectionsEnabled()) return;
  if (window.location.pathname !== '/company/coverage-integrations') return;
  const token = new URLSearchParams(window.location.hash.slice(1)).get(
    'invitation',
  );
  if (!/^link_[A-Za-z0-9_-]{43}$/.test(token || '')) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ token, expiresAt: Date.now() + 3600000 }),
    );
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search,
    );
  } catch {
    /* Keep the fragment when this browser forbids tab storage. */
  }
}
export function pendingConnectionInvitation() {
  const fragment = new URLSearchParams(window.location.hash.slice(1)).get(
    'invitation',
  );
  if (fragment) return fragment;
  try {
    const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (value?.expiresAt > Date.now()) return value.token;
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* Missing/disabled storage is an ordinary state. */
  }
  return '';
}
export function clearConnectionInvitation() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
  window.history.replaceState(
    null,
    '',
    window.location.pathname + window.location.search,
  );
}
